import { render, staticRenderFns, recyclableRender, components } from "./images.vue?vue&type=template&id=2ef8583c&scoped=true&"
var renderjs
import script from "./images.vue?vue&type=script&lang=js&"
export * from "./images.vue?vue&type=script&lang=js&"
import style0 from "./images.vue?vue&type=style&index=0&id=2ef8583c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../Software/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef8583c",
  null,
  false,
  components,
  renderjs
)

export default component.exports